module.exports = __webpack_public_path__ + "images/d4a5a963abc72d8df4df0069eb43757d.png";